<div class="dropdown-panel">
    <div
            class="selection"
            *ngFor="let number of [0,1,2,3,4,5]"
            (click)="selectQuantity(number)"
    >
        <p class="selection__label">
            {{number}} {{
                number == 1
                ?
                ('quantity-dropdown-panel.box'|translate)
                :
                ('quantity-dropdown-panel.boxes' | translate)
            }}
        </p>
    </div>
    <div
            class="selection custom-quantity"
    >
        <input
                class="custom-quantity__field"
                [formControl]="customQuantityControl"
                type="number"
                [placeholder]="'quantity-dropdown-panel.other_quantity' | translate"
                min="0"
                step="1"
                (keydown.enter)="sendQuantity()"
        >
        <button
                customButton appearance="text"
                *ngIf="customQuantityControl.valid"
                (click)="sendQuantity()"
        >
            <svg-icon src="./assets/icons/check.svg"></svg-icon>
        </button>
    </div>
</div>
